<div class="dialog-card-view cibil-dialog">
    <div class="dialog-header">
        <div class="dialog-title">
            <h1 class="dc-title-xl">Bank Verification Failed</h1>
        </div>
        <div class="dialog-close-btn">
            <mat-icon class="close-icon" mat-dialog-close>
                <img class="primary-icon" src="assets/svg/icons/cross.svg" />
            </mat-icon>
        </div>
    </div>

    <mat-dialog-content>
        <div class="fail-icon">
            <img src="assets/svg/icons/cross-circle-fill-danger.svg" alt="fail" />
        </div>

        <h2 class="fail-title">We Couldn't Fetch Your Statement</h2>

        <p class="fail-subtext">Looks like your bank statement couldn’t be retrieved automatically.</p>

        <div class="fail-hint">No worries! You can verify your account securely using Net Banking instead.</div>

        <div class="fail-actions">
            <button class="primary-btn" (click)="retryWithNb()">Retry</button>

            <div class="or-line">
                <span>or</span>
            </div>

            <button class="secondary-btn" (click)="proceedWithNb()">Proceed with Net Banking</button>
        </div>
    </mat-dialog-content>
</div>
